import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { ApiService } from './api.service';
import { Campaign } from '../types/campaign-types';

@Injectable({ providedIn: 'root' })
export class CampaignsService {
  private apiService = inject(ApiService);
  baseRoute = 'tlh-campaigns';

  // Cached + shared so every menu re-render doesn't re-fetch the same list.
  private campaigns$?: Observable<Campaign[]>;

  getActiveCampaigns(): Observable<Campaign[]> {
    if (!this.campaigns$) {
      this.campaigns$ = this.apiService
        .request<Campaign[]>('GET', this.baseRoute)
        .pipe(shareReplay({ bufferSize: 1, refCount: true }));
    }
    return this.campaigns$;
  }

  getCampaign(id: number): Observable<Campaign> {
    return this.apiService.request<Campaign>('GET', `${this.baseRoute}/${id}`);
  }

  clearCache(): void {
    this.campaigns$ = undefined;
  }
}
